export const APP_ROUTES = Object.freeze({
  home: '',
  go: 'go',
  selectFlight: 'chon-chuyen-bay',
  passengerInformation: 'thong-tin-hanh-khach',
  selectService: 'chon-dich-vu',
  payment: 'thanh-toan',
  paymentSuccess: 'thanh-toan-thanh-cong',
  // Alias trung tính của paymentSuccess dùng cho màn chi tiết booking: một
  // booking failed/pending cũng mở màn này, nên URL không nên nói "thành công".
  bookingDetail: 'chi-tiet-booking',
  cheapTicket: 'san-ve-re',
  promotion: 'khuyen-mai',
  contact: 'lien-he',
  onepayResult: 'onepay-ket-qua',
});
